/*
This file was created by the script build.py 
*/

import {buttonOnClick, checkAllButtons, callAllCategories} from "./globalFilterUI"
import {allCheckboxesState} from "./checkboxState"

// show or hide buttons
$(document).ready(function(){
    $("#iconFinalStates").click(function(){
        var buttons = document.getElementById("buttonWrapperFinalStates")
        const iconId = "#"+$(this).attr('id');
        if(buttons.classList.contains("show")){
            $(buttons).hide()
            buttons.classList.remove("show")
            $(iconId).toggleClass("bi bi-caret-up-fill", false)
            $(iconId).toggleClass("bi bi-caret-down-fill", true)
        }
        else{
            $(buttons).show()
            buttons.classList.add("show")
            $(iconId).toggleClass("bi bi-caret-down-fill", false)
            $(iconId).toggleClass("bi bi-caret-up-fill", true)
        }
    })
})

//checkbox Final States
document.getElementById("categoryFinalStates").onclick=function(){
    const checkboxId = $(this).attr('id')
    var checkbox = document.getElementById(checkboxId)
    checkbox.checked = false
    if(allCheckboxesState[checkboxId].checked){
        checkbox.checked = true
    }
    else if(allCheckboxesState[checkboxId].indeterminate){
        checkbox.indeterminate = true
    }
    else{
        checkbox.checked = false
    }
    
    const iconId = "#iconFinalStates";
    var buttons = document.getElementById("buttonWrapperFinalStates")
    if(buttons.classList.contains("show")){
        $(buttons).hide()
        buttons.classList.remove("show")
        $(iconId).toggleClass("bi bi-caret-up-fill", false)
        $(iconId).toggleClass("bi bi-caret-down-fill", true)
    }
    else{
        $(buttons).show()
        buttons.classList.add("show")
        $(iconId).toggleClass("bi bi-caret-down-fill", false)
        $(iconId).toggleClass("bi bi-caret-up-fill", true)
    }
    allCheckboxesState[checkboxId].checked = checkbox.checked

}

//Name Final States
document.getElementById("finalStatesLabel").onclick=function(){
    const iconId = "#iconFinalStates";
    var buttons = document.getElementById("buttonWrapperFinalStates")
    if(buttons.classList.contains("show")){
        $(buttons).hide()
        buttons.classList.remove("show")
        $(iconId).toggleClass("bi bi-caret-up-fill", false)
        $(iconId).toggleClass("bi bi-caret-down-fill", true)
    }
    else{
        $(buttons).show()
        buttons.classList.add("show")
        $(iconId).toggleClass("bi bi-caret-down-fill", false)
        $(iconId).toggleClass("bi bi-caret-up-fill", true)
    }
    
}

//Button: "select all buttons"
document.getElementById("buttonFinalStatesSelectAll").onclick=function(){
    const checkboxId = "categoryFinalStates"
    var checkbox = document.getElementById(checkboxId)
    checkbox.indeterminate = false
    checkbox.checked = true
    allCheckboxesState[checkboxId].checked = checkbox.checked
    checkAllButtons({
        "checkboxId" : checkboxId
    })

    callAllCategories()
}

//Button: "select none buttons"
document.getElementById("buttonFinalStatesSelectNone").onclick=function(){
    const checkboxId = "categoryFinalStates"
    var checkbox = document.getElementById(checkboxId)
    checkbox.checked = false
    checkbox.indeterminate = false
    allCheckboxesState[checkboxId].checked = checkbox.checked
    allCheckboxesState[checkboxId].indeterminate = checkbox.indeterminate
    checkAllButtons({
        "checkboxId" : checkboxId
    })

    callAllCategories()
}

// any-Button Final States
document.getElementById("buttonFinalStatesAny").onclick = function(){
    var buttonAny = document.getElementById("buttonFinalStatesAny")
    var buttonAll = document.getElementById("buttonFinalStatesAll")
    buttonAny.classList.add("chosen","text-light","no-click");
    buttonAll.classList.remove("chosen","text-light","no-click")
    callAllCategories()
}

// all-Button Final States
document.getElementById("buttonFinalStatesAll").onclick = function(){
    var buttonAny = document.getElementById("buttonFinalStatesAny")
    var buttonAll = document.getElementById("buttonFinalStatesAll")
    buttonAll.classList.add("chosen","text-light","no-click");
    buttonAny.classList.remove("chosen","text-light","no-click")
    callAllCategories()
}


//Button Jets1jet in Final States change color on click Event
document.getElementById("buttonFinalStatesJets1jet").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Jets2jets in Final States change color on click Event
document.getElementById("buttonFinalStatesJets2jets").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Jets3jets in Final States change color on click Event
document.getElementById("buttonFinalStatesJets3jets").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button JetsAllhadronic in Final States change color on click Event
document.getElementById("buttonFinalStatesJetsAllhadronic").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button JetsBJets in Final States change color on click Event
document.getElementById("buttonFinalStatesJetsBJets").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button JetsCJets in Final States change color on click Event
document.getElementById("buttonFinalStatesJetsCJets").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button JetsBoostedSubstructure in Final States change color on click Event
document.getElementById("buttonFinalStatesJetsBoostedSubstructure").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button JetsForwardjets in Final States change color on click Event
document.getElementById("buttonFinalStatesJetsForwardjets").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Singlelepton in Final States change color on click Event
document.getElementById("buttonFinalStatesSinglelepton").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button DiLeptonOppositecharge in Final States change color on click Event
document.getElementById("buttonFinalStatesDiLeptonOppositecharge").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button DiLeptonSamecharge in Final States change color on click Event
document.getElementById("buttonFinalStatesDiLeptonSamecharge").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button 3leptons in Final States change color on click Event
document.getElementById("buttonFinalStates3leptons").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

